import cl from 'clsx'
import { forwardRef, HTMLAttributes } from 'react'
import { STATUS_CONTENT, type StatusContent } from '../data'
import classes from './StatusBadge.module.scss'

export type StatusBadgeProps = Pick<StatusContent, 'value'> &
    Pick<HTMLAttributes<HTMLDivElement>, 'children' | 'className' | 'onClick'>

export const StatusBadge = forwardRef<HTMLDivElement, StatusBadgeProps>(
    function StatusBadge(
        { value, children, className, onClick },
        forwardedRef
    ) {
        const { Icon: StatusIcon, title, style } = STATUS_CONTENT[value]

        return (
            <div
                ref={forwardedRef}
                className={cl(classes.root, className)}
                onClick={onClick}
                style={style}
            >
                {StatusIcon && <StatusIcon className={classes.icon} />}
                <div className={classes.text}>{title}</div>
                {children}
            </div>
        )
    }
)
